var path = 'app/newsletterSubscription/newsletterSubscription.tpl.html';
var html = "<div> <button type=button class=\"btn btn-secondary\" ng-click=$ctrl.openNewsletterModal()> Subscribe to Newsletter </button> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;